export const YOUTUBE_URL = {
  BASE: '(https?:\\/\\/)?(www\\.)?(youtube\\.com|youtu\\.?be)\\/[^\\s\\n\\r]+',
  get URL_REGEXP() {
    return new RegExp(`^${this.BASE}$`)
  },
  get URL_IN_TEXT_REGEXP() {
    return new RegExp(this.BASE, 'gm')
  }
}
